import { api, request } from '@/api/index';
import { SearchGeocodeReGeo, ConvertCoordinate } from '@/api/car/car.js';
import app from '@/common/public.js';

export default {
  state: {
    carPlatFormType: '',
    placeType: 1, // 1- 出发地 2-目的地
    mapCenter: [116.396087, 39.909882], // 地图中心点 北京-[116.396087, 39.909882] 苏州火车站-[120.610868, 31.329679] 协鑫广场-[120.716725, 31.324579]
    curPositionInfo: {}, // 当前位置信息
    startLocation: [], // 用车起始点位置
    endLocation: [], // 用车目的地位置
    startPlaceInfo: {}, // 用车起始地信息
    endPlaceInfo: {}, // 用车目的地信息
    locationInfo: {}, // 位置信息
    greenAreaInfo: {}, // 当前绿区信息
    startPlaceCityInfo: {}, // 起始位置城市信息
    endPlaceCityInfo: {}, // 目的地位置城市信息
    carUseTimeInfo: {
      timeVal: '',
      timeValFormat: '现在出发',
    }, //用车时间信息
    requestLoading: false, // 请求位置信息加载状态
    carAbOrderList: [], // 用车未完成订单列表
    mapEnlarge: false, // 地图是否放大
    greenPopupShow: false, // 是否显示绿区
    errStatus: false, // 是否是uni定位错误
    count: 0, // 请求次数
    positionDetail: {}, // 当前位置详细信息
    mainInfo: {
      placeType: 1, // 1-出发地 2-目的地
      useTypeItem: {}, // 用车场景选项
    },
    nearbyPoints: [], // 附近点初始定位信息
    userSelectedPrice: null, // 记录用户勾选的用车运力
    initialPosition: null, // 记录初始定位信息，用来在搜索地点页面可以记录距离
  },
  mutations: {
    // 设置用车平台
    setCarPlatFormType(state, data) {
      state.carPlatFormType = data;
    },
    // 设置地图中心点
    setMapCenter(state, data) {
      state.mapCenter = data;
    },
    // 设置当前位置信息
    setCurPosition(state, data) {
      state.curPositionInfo = data;
    },
    // 设置用车起始点位置
    setStartLocation(state, data) {
      state.startLocation = data;
    },
    // 设置用车起始地信息
    setStartPlaceInfo(state, data) {
      state.startPlaceInfo = data;
    },
    // 设置用车目的地位置
    setEndLocation(state, data) {
      state.endLocation = data;
    },
    // 设置用车目的地信息
    setEndPlaceInfo(state, data) {
      state.endPlaceInfo = data;
    },
    setRequestLoading(state, data) {
      state.requestLoading = data;
    },
    setErrStatus(state, data) {
      state.errStatus = data;
    },
    setLocationInfo(state, data) {
      state.locationInfo = data;
    },
    // 设置用车类型
    setPlaceType(state, data) {
      state.placeType = data;
    },
    // 设置绿区信息
    setGreenAreaInfo(state, data) {
      state.greenAreaInfo = data;
    },
    // 设置起始地城市信息
    setStartPlaceCityInfo(state, data) {
      state.startPlaceCityInfo = data;
    },
    // 设置目的地城市信息
    setEndPlaceCityInfo(state, data) {
      state.endPlaceCityInfo = data;
    },
    // 设置用车时间信息
    setCarUseTimeInfo(state, data) {
      state.carUseTimeInfo = data;
    },
    // 设置未完成订单数据
    setAbOrderList(state, data) {
      state.carAbOrderList = data;
    },
    // 设置放大缩小状态
    setMapEnlarge(state, data) {
      state.mapEnlarge = data;
    },
    setGreenPopupShow(state, data) {
      state.greenPopupShow = data;
    },
    setPositionDetail(state, data) {
      const { result, needSave } = data;
      // 实时保存获取的定位信息
      state.positionDetail = result;
    },
    updateCarMainInfo(state, data) {
      state.mainInfo = {
        ...state.mainInfo,
        ...data,
      };
    },
    setCarStartPlace(state, data) {
      state.startPlaceInfo = data; // 设置用车起始地信息
    },
    setCarEndPlace(state, data) {
      state.endPlaceInfo = data; // 设置用车目的地信息
    },
    setNearbyPoint(state, data) {
      state.nearbyPoints = data; // 设置初始附近点信息
    },
    recordUserSelectedPrice(state, data) {
      state.userSelectedPrice = data;
    },
    setInitialPosition(state, data) {
      state.initialPosition = data;
    },
  },
  actions: {
    // 获取定位点详情
    getPositionDetail({ commit, state }, data) {
      const { location, operateType, needSave, Name, saveType } = data;
      const { mainInfo } = state;
      const centerLocation = location.split(',');
      return new Promise((resolve, reject) => {
        request({
          apiName: SearchGeocodeReGeo,
          params: {
            Coordtype: 'gcj02',
            CoordinateList: [
              {
                Lon: centerLocation[0],
                Lat: centerLocation[1],
              },
            ],
            GetTimes: ++state.count,
            IsSearchRecommendPoint: 1,
            CarBoardType: mainInfo.placeType,
            IsProcessAdsorb: 1,
            IsTravelBussiness: 1,
            OperateType: operateType,
          },
        }).then((res) => {
          if (res.Code == '0000') {
            let data = res.Data;
            if (data) {
              data.relativeLocation = data.Regeocode ? data.Regeocode.Location.split(',') : []; // 这里添加一个初始的相对坐标
              const { Regeocode } = data;
              // 这里推荐点和Regeocode转化成统一的数据格式
              const result = {
                ...data,
                ExtraRecommendPointList: (data.ExtraRecommendPointList || []).map((item) => {
                  return {
                    Name: item.Name,
                    Address: item.Address,
                    IsAdsorb: item.IsAdsorb,
                    CityName: item.CityName || data.CityName,
                    CityCode: item.CityCode || data.CityCode,
                    Longitude: item.Longitude,
                    Latitude: item.Latitude,
                    BelongToAOIType: data.BelongToAOIType || 0,
                    Distance: item.Distance,
                  };
                }),
                RecommendPointList: (data.RecommendPointList || []).map((item) => {
                  return {
                    Type: 4, // 4推荐点
                    Name: item.Name,
                    Address: item.Address,
                    IsAdsorb: item.IsAdsorb,
                    CityName: item.CityName || data.CityName,
                    CityCode: item.CityCode || data.CityCode,
                    Longitude: item.Longitude,
                    Latitude: item.Latitude,
                    BelongToAOIType: data.BelongToAOIType || 0,
                    Distance: item.Distance,
                  };
                }),
                Regeocode: {
                  Type: 1, // 1上车点
                  Name: Name ? Name : Regeocode.Name, // 这里防止坐标点的名称重新搜索后改变，所以需要手动赋值
                  Address: Regeocode.Address,
                  IsAdsorb: Regeocode.IsAdsorb,
                  CityName: Regeocode.CityName || data.CityName,
                  CityCode: Regeocode.CityCode || data.CityCode,
                  Longitude: Regeocode.Location.split(',')[0],
                  Latitude: Regeocode.Location.split(',')[1],
                  BelongToAOIType: data.BelongToAOIType || 0,
                },
                RecommendChoiceList: (data.RecommendChoiceList || [])
                  .map((item) => {
                    return (item.SubItemList || []).map((sitem) => {
                      return {
                        Type: 4, // 4推荐点
                        Name: item.Name + '-' + sitem.SubName,
                        Address: item.Name + '-' + sitem.SubName,
                        IsAdsorb: sitem.IsAdsorb || 1,
                        CityName: sitem.CityName || data.CityName,
                        CityCode: sitem.CityCode || data.CityCode,
                        Longitude: sitem.Longitude,
                        Latitude: sitem.Latitude,
                        BelongToAOIType: data.BelongToAOIType || 0,
                        SubItemList: (sitem.SubItemList || []).map((it) => {
                          return {
                            Type: 4, // 4推荐点
                            Name: it.SubName,
                            Address: it.SubName,
                            IsAdsorb: it.IsAdsorb || 1,
                            CityName: it.CityName || data.CityName,
                            CityCode: sitem.CityCode || data.CityCode,
                            Longitude: it.Longitude,
                            Latitude: it.Latitude,
                            BelongToAOIType: data.BelongToAOIType || 0,
                          };
                        }),
                      };
                    });
                  })
                  .flat(),
              };
              result.RecommendPointList = getRecommendPointList(result.RecommendPointList, result.Regeocode.Longitude);
              result.RecommendChoiceList = getRecommendPointList(
                result.RecommendChoiceList,
                result.Regeocode.Longitude,
              );
              result.RecommendChoiceList.forEach((item) => {
                item.SubItemList = getRecommendPointList(item.SubItemList, item.SubItemList[0]?.Longitude);
              });
              if (saveType === 'nearby') {
                commit('setNearbyPoint', result.ExtraRecommendPointList || []);
              } else {
                if (mainInfo.placeType === 1) {
                  commit('setNearbyPoint', result.ExtraRecommendPointList || []);
                }
                commit('setPositionDetail', { result, needSave });
              }
              resolve(result);
            } else {
              reject('获取定位信息失败');
            }
          } else {
            app.Toast(res.Msg);
            reject(res.Msg);
          }
        });
      });
    },
  },
};

// 获取推荐点样式
function getRecommendPointList(recommendPointList, lng) {
  if (!recommendPointList || recommendPointList.length === 0) {
    return [];
  }
  recommendPointList.forEach((item, index) => {
    if (item.Longitude < lng) {
      item.Returnvalue = 'left';
    } else {
      item.Returnvalue = 'right';
    }
    recommendPointList.forEach((sitem, sindex) => {
      if (item.Name != sitem.Name) {
        let latdis = sitem.Latitude - item.Latitude;
        if (latdis > 0 && latdis < 0.0001 && sitem.Returnvalue && sitem.Returnvalue == item.Returnvalue) {
          item.Returnvalue = 'bottom';
        } else if (latdis < 0 && latdis > -0.0001 && sitem.Returnvalue && sitem.Returnvalue == item.Returnvalue) {
          sitem.Returnvalue = 'bottom';
        }
      }
    });
  });
  return recommendPointList;
}
